// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AssetCreateIn } from './assetCreateIn.zod.ts';
import { FromExtractionCase } from './fromExtractionCase.zod.ts';
import { FromExtractionMaterial } from './fromExtractionMaterial.zod.ts';
import { FromExtractionSection } from './fromExtractionSection.zod.ts';

export const fromExtractionInCasesMax = 20;

export const fromExtractionInMaterialsMax = 10;

export const fromExtractionInSectionsMax = 60;

export const FromExtractionIn = zod.object({
  "asset": AssetCreateIn,
  "cases": zod.array(FromExtractionCase).max(fromExtractionInCasesMax).optional(),
  "materials": zod.array(FromExtractionMaterial).max(fromExtractionInMaterialsMax).optional(),
  "sections": zod.array(FromExtractionSection).max(fromExtractionInSectionsMax).optional()
});

export type FromExtractionIn = zod.input<typeof FromExtractionIn>;
export type FromExtractionInOutput = zod.output<typeof FromExtractionIn>;
